// import { toast } from "react-toastify";
// import DeleteBtn from "../../../../components/buttons/DeleteBtn";
// import { deleteLibCategoryform } from "../../../../hooks/apiAxios";
// import { useTranslation } from 'react-i18next';

import { useAdminLibCategory } from "../../../../context/Admins/AdminLibCategoryContext";
import Pagination from "../../../../utilities/Pagination";
import LibCategoryModify from "./LibCategoryModify";

export default function LibCatergorySetting() {
    const { loading, setLoading, currentPage, setCurrentPage, libCategory } = useAdminLibCategory();
    const totalPages = libCategory?.data?.paginationInfo.totalPagesCount;

    // in case you want to use this function in the future

    // const { t } = useTranslation();

    // async function deleteBookBtn(id) {
    //     setLoading(true);
    //     try {
    //         const response = await deleteLibCategoryform(id);
    //         if (response.data.isSuccess) {
    //             // setDataUpdate(true);
    //             toast.success("تم حذف التصنيف ..شكرا لك")
    //             setTimeout(() => {
    //                 window.location.reload();
    //             }, 3000);

    //         } else {
    //             toast.warn("حدث خطأ ما، حاول مرة أخرى");
    //         }
    //     } catch (error) {
    //         console.error("Error during form submission: ", error);
    //         toast.error("حدث خطأ ما، تواصل مع الدعم");
    //     } finally {
    //         setLoading(false);

    //     }
    // }

    if (!libCategory) return
    <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (<>
        <div className="row row-cols-3">
            {libCategory?.data?.result.map((category) => (
                <div key={category.id} className="col text-center mb-2 position-relative">
                    <button type="button" className="btn-masar-sm w-100" data-bs-toggle="modal" data-bs-target={`#exampleModal_${category.id}`}>
                        {category.nameAr}
                    </button>
                    {/* In case we need to run this in future */}
                    {/* <DeleteBtn
                        handleOnClick={() => deleteBookBtn(category.id)}
                        t={t}
                        small={true}
                    /> */}
                    <LibCategoryModify
                        category={category}
                        id={category.id}
                        loading={loading}
                        setLoading={setLoading}
                    />
                </div>
            ))}
        </div>
        {totalPages > 1 &&
            <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages} />
        }
    </>
    )
}